export const AUTOCAR = 'autocar';

export const AUTOCARUTMLINKS = [
  'utm_source=haymarket_autocar',
  'utm_medium=partnership'
];

export const WHATCARUTMLINKS = [
  'utm_source=haymarket_whatcar',
  'utm_medium=partnership'
];



// WEBPACK FOOTER //
// ./src/utils/utmLinks/utm.links.js